import React from "react";
import { EaseModal } from "../../../../../../libs/EaseModal";
import { Text1 } from "../../../../../../styles";
import { RecordOfflinePaymentForm } from "../../../Forms/VendorInvoice/RecordOfflinePayment";

const RecordOfflinePayementModal = (props) => {
  const renderTitle = () => {
    return (
      <Text1 className="d-block mb-4" strong>
      Record Offline Payment
      </Text1>
    );
  };

  return (
    <EaseModal
      width={450}
      title={false}
      visible={props.visible}
      onCancel={props.toggleRecordOfflinePaymentModal}
      centered
      hideFooter
      destroyOnClose
    >
      {renderTitle()}
      <RecordOfflinePaymentForm
        vendorInvoice={props.vendorInvoice}
        fetchList={props.fetchList}
        loading={props.loading}
        toggleRecordOfflinePaymentModal={props.toggleRecordOfflinePaymentModal}
      />
    </EaseModal>
  );
};

RecordOfflinePayementModal.defaultProps = {
  vendorInvoice: {},
};

export { RecordOfflinePayementModal };
